import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=4fb73bd2&scoped=true"
import script from "./UploadModal.vue?vue&type=script&lang=ts"
export * from "./UploadModal.vue?vue&type=script&lang=ts"
import style0 from "./UploadModal.vue?vue&type=style&index=0&id=4fb73bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb73bd2",
  null
  
)

export default component.exports